"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeshHost = void 0;
const model_1 = require("../../../data/model");
const random_1 = require("../../../crypto/random");
const store_1 = require("../../../storage/store");
class MeshHost {
    constructor(mesh, streamedReplyCb, peerSourceReqCb) {
        this.mesh = mesh;
        this.streamedReplyCb = streamedReplyCb;
        this.peerSourceReqCb = peerSourceReqCb;
        this.pendingPeersRequests = new Map();
        this.pendingPeerForEndpointRequests = new Map();
        this.stores = new Map();
    }
    static isCommand(msg) {
        const type = msg === null || msg === void 0 ? void 0 : msg.type;
        return (type === 'join-peer-group' ||
            type === 'check-peer-group-usage' ||
            type === 'leave-peer-group' ||
            type === 'sync-objects-with-peer-group' ||
            type === 'stop-sync-objects-with-peer-group' ||
            type === 'start-object-broadcast' ||
            type === 'stop-object-broadcast' ||
            type === 'find-object-by-hash' ||
            type === 'find-object-by-hash-suffix' ||
            type === 'object-discovery-reply' ||
            type === 'object-discovery-end' ||
            type === 'forward-get-peers-reply' ||
            type === 'forward-get-peer-for-endpoint-reply');
    }
    static isStreamedReply(msg) {
        const type = msg === null || msg === void 0 ? void 0 : msg.type;
        return (type === 'object-discovery-reply' ||
            type === 'object-discovery-end');
    }
    static isPeerSourceRequest(msg) {
        const type = msg === null || msg === void 0 ? void 0 : msg.type;
        return (type === 'get-peers' || type === 'get-peer-for-endpoint');
    }
    execute(command) {
        //let error: string | undefined;
        var _a, _b;
        if (command.type === 'join-peer-group') {
            const join = command;
            let peerSource = new PeerSourceProxy(this, join.peerGroupId);
            const identity = (join.localPeerIdentity === undefined ? undefined : model_1.HashedObject.fromLiteralContext(join.localPeerIdentity));
            if (identity !== undefined && join.localPeerIdentityKeyPair !== undefined) {
                identity._keyPair = model_1.HashedObject.fromLiteralContext(join.localPeerIdentityKeyPair);
            }
            let localPeer = {
                endpoint: join.localPeerEndpoint,
                identityHash: join.localPeerIdentityHash,
                identity: identity
            };
            this.mesh.joinPeerGroup({ id: join.peerGroupId, localPeer: localPeer, peerSource: peerSource }, join.config, join.usageToken);
        }
        else if (command.type === 'leave-peer-group') {
            const leave = command;
            this.mesh.leavePeerGroup(leave.usageToken);
        }
        else if (command.type === 'sync-objects-with-peer-group') {
            const syncObjs = command;
            let objs = [];
            let tokens = undefined;
            if (syncObjs.usageTokens !== undefined) {
                tokens = new Map();
            }
            let context = new model_1.Context();
            context.fromLiteralContext(syncObjs.objContext);
            for (const hash of syncObjs.objContext.rootHashes) {
                const obj = model_1.HashedObject.fromContext(context, hash);
                objs.push(obj);
                if (tokens !== undefined) {
                    tokens.set(hash, syncObjs.usageTokens[hash]);
                }
            }
            for (const [hash, obj] of context.objects.entries()) {
                if (syncObjs.stores[hash] !== undefined) {
                    const backendName = syncObjs.stores[hash]['backendName'];
                    const dbName = syncObjs.stores[hash]['dbName'];
                    if (!this.stores.has(backendName)) {
                        this.stores.set(backendName, new Map());
                    }
                    let db = (_a = this.stores.get(backendName)) === null || _a === void 0 ? void 0 : _a.get(dbName);
                    if (db === undefined) {
                        db = store_1.Store.load(backendName, dbName);
                        if (db !== undefined) {
                            (_b = this.stores.get(backendName)) === null || _b === void 0 ? void 0 : _b.set(dbName, db);
                        }
                    }
                    if (db !== undefined) {
                        obj.setStore(db);
                    }
                    else {
                        console.log('WARNING: missing store for ' + hash);
                    }
                }
            }
            this.mesh.syncManyObjectsWithPeerGroup(syncObjs.peerGroupId, objs.values(), syncObjs.mode, syncObjs.gossipId, tokens);
        }
        else if (command.type === 'stop-sync-objects-with-peer-group') {
            const stopSyncObjs = command;
            this.mesh.stopSyncManyObjectsWithPeerGroup(stopSyncObjs.usageTokens.values());
        }
        else if (command.type === 'start-object-broadcast') {
            const startBcast = command;
            let obj = model_1.HashedObject.fromLiteralContext(startBcast.objContext);
            this.mesh.startObjectBroadcast(obj, startBcast.linkupServers, startBcast.replyEndpoints, startBcast.broadcastedSuffixBits, startBcast.usageToken);
        }
        else if (command.type === 'stop-object-broadcast') {
            const stopBcast = command;
            this.mesh.stopObjectBroadcast(stopBcast.usageToken);
        }
        else if (command.type === 'find-object-by-hash' ||
            command.type === 'find-object-by-hash-suffix') {
            const find = command;
            if (!find.retry) {
                const streamId = command.streamId;
                let replyStream;
                if (command.type === 'find-object-by-hash') {
                    replyStream = this.mesh.findObjectByHash(find.hash, find.linkupServers, find.replyEndpoint, find.count, find.maxAge, find.strictEndpoints);
                }
                else {
                    replyStream = this.mesh.findObjectByHashSuffix(find.hashSuffix, find.linkupServers, find.replyEndpoint, find.count, find.maxAge, find.strictEndpoints);
                }
                const tt = setTimeout(async () => {
                    try {
                        while (!replyStream.atEnd()) {
                            const discov = await replyStream.next();
                            let reply = {
                                type: 'object-discovery-reply',
                                streamId: streamId,
                                source: discov.source,
                                destination: discov.destination,
                                hash: discov.hash,
                                objContext: discov.object.toLiteralContext(),
                                timestamp: discov.timestamp
                            };
                            this.streamedReplyCb(reply);
                        }
                    }
                    finally {
                        let replyEnd = {
                            type: 'object-discovery-end',
                            streamId: streamId
                        };
                        this.streamedReplyCb(replyEnd);
                        clearTimeout(tt);
                    }
                }, 0);
            }
            else {
                if (command.type === 'find-object-by-hash') {
                    this.mesh.findObjectByHashRetry(find.hash, find.linkupServers, find.replyEndpoint, find.count);
                }
                else {
                    this.mesh.findObjectByHashSuffixRetry(find.hashSuffix, find.linkupServers, find.replyEndpoint, find.count);
                }
            }
        }
        else if (command.type === 'forward-get-peers-reply') {
            const reply = command;
            let ex = this.pendingPeersRequests.get(reply.requestId);
            if (ex !== undefined) {
                if (reply.error) {
                    ex.reject('Received rejection through remoting');
                }
                else {
                    ex.resolve(reply.peers);
                }
            }
        }
        else if (command.type === 'forward-get-peer-for-endpoint-reply') {
            const reply = command;
            let ex = this.pendingPeerForEndpointRequests.get(reply.requestId);
            if (ex !== undefined) {
                if (reply.error) {
                    ex.reject('Received rejection through remoting');
                }
                else {
                    ex.resolve(reply.peerInfo);
                }
            }
        }
    }
    registerPeersRequest(requestId, executor) {
        this.pendingPeersRequests.set(requestId, executor);
    }
    registerPeerForEndpointRequest(requestId, executor) {
        this.pendingPeerForEndpointRequests.set(requestId, executor);
    }
}
exports.MeshHost = MeshHost;
class PeerSourceProxy {
    constructor(host, peerGroupId) {
        this.host = host;
        this.peerGroupId = peerGroupId;
    }
    getPeers(count) {
        let requestId = new random_1.RNGImpl().randomHexString(128);
        let result = new Promise((resolve, reject) => {
            this.host.registerPeersRequest(requestId, { resolve: resolve, reject: reject });
        });
        this.host.peerSourceReqCb({
            type: 'get-peers',
            peerGroupId: this.peerGroupId,
            count: count,
            requestId: requestId
        });
        return result;
    }
    getPeerForEndpoint(endpoint) {
        let requestId = new random_1.RNGImpl().randomHexString(128);
        let result = new Promise((resolve, reject) => {
            this.host.registerPeerForEndpointRequest(requestId, { resolve: resolve, reject: reject });
        });
        this.host.peerSourceReqCb({
            type: 'get-peer-for-endpoint',
            peerGroupId: this.peerGroupId,
            endpoint: endpoint,
            requestId: requestId
        });
        return result;
    }
}
//# sourceMappingURL=MeshHost.js.map